<template>
  <div>
    <b-overlay :show="showLoading" no-wrap/>
    <app-collapse accordion type="margin" >
      <updated-fiche-entreprise-prospect-lien  
                 :prospect-principal-data="prospectPrincipal"
                 :prospect-data="prospectLocal" 
                 @update-client-entreprise-returned="UpdateClientEntrepriseReturned"
      >
      </updated-fiche-entreprise-prospect-lien>
      <!--  -->
      <!--  -->
      <app-collapse-item title="Associés" v-if="particulierDataAssocie.length > 0">
        <card-connexite :particulier-data="particulierDataAssocie" @update-connexite-prospect="editProspect"
            @remove-connexite-prospect="removeConnexite"
            @go-to-another-fiche-client="showProspect" />
            <vue-good-table
            v-show="false"
              :columns="particulierColumns"
              :rows="particulierDataAssocie"
              :rtl="direction"
              style-class="vgt-table condensed"
              :pagination-options="{
                enabled: false,
                mode: 'records',
                perPage: pageLength,
                rowsPerPageLabel: '',
                dropdownAllowAll: false,
                perPageDropdownEnabled: false,
                nextLabel: 'Suivant',
                prevLabel: 'Précédent',
                ofLabel: 'de',
                infoFn: params => ``
              }"
            >
              <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'lienable.nom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                    <a :style="[{'text-decoration': 'underline'}]">
                      {{ props.row.lienable.nom }}
                    </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.prenom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                <a :style="[{'text-decoration': 'underline'}]">
                  {{ props.row.lienable.prenom }}
                </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.statut_fiche'">
                <b-badge :variant="props.row.lienable.statut_fiche ==='Ancien Client' ? typeClientVariant('Ancien') : typeClientVariant(props.row.lienable.statut_fiche)">{{ props.row.lienable.statut_fiche}}</b-badge>
              </div>
              <span v-else-if="props.column.field === 'lien_professionnel'">
                <b-badge :variant="sourceVariant(props.row.lien_professionnel)">
                  {{ capitalizeFirstLetter(props.row.lien_professionnel) }}
                </b-badge>
              </span>
              <span v-else-if="props.column.field === 'actions'">
                <span>
                  <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                    <template v-slot:button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                    </template>
                    <b-dropdown-item @click="editProspect(props.row)">
                      <feather-icon icon="EditIcon" class="mr-50" />
                      <span>Éditer</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="removeConnexite(props.row)">
                      <feather-icon icon="TrashIcon" class="mr-50" />
                      <span>Supprimer la connexité</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
              </template>
              <!-- <template slot="pagination-bottom" slot-scope="props">
                <b-row class="align-items-center">
                  <b-col>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </template> -->
              <div slot="emptystate" class="text-center align-middle">
                <span>Aucune donn&eacute;e disponible dans le tableau</span>
              </div>
            </vue-good-table>
      </app-collapse-item>
      <!--  -->
      <!--  -->
      <app-collapse-item title="Dirigeants" v-if="particulierDataDirigeant.length > 0">
        <card-connexite :particulier-data="particulierDataDirigeant" @update-connexite-prospect="editProspect"
            @remove-connexite-prospect="removeConnexite"
            @go-to-another-fiche-client="showProspect" />
            <vue-good-table
            v-show="false"
              :columns="particulierColumns"
              :rows="particulierDataDirigeant"
              :rtl="direction"
              style-class="vgt-table condensed"
              :pagination-options="{
                enabled: false,
                mode: 'records',
                perPage: pageLength,
                rowsPerPageLabel: '',
                dropdownAllowAll: false,
                perPageDropdownEnabled: false,
                nextLabel: 'Suivant',
                prevLabel: 'Précédent',
                ofLabel: 'de',
                infoFn: params => ``
              }"
            >
              <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'lienable.nom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                    <a :style="[{'text-decoration': 'underline'}]">
                      {{ props.row.lienable.nom }}
                    </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.prenom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                <a :style="[{'text-decoration': 'underline'}]">
                  {{ props.row.lienable.prenom }}
                </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.statut_fiche'">
                <b-badge :variant="props.row.lienable.statut_fiche ==='Ancien Client' ? typeClientVariant('Ancien') : typeClientVariant(props.row.lienable.statut_fiche)">{{ props.row.lienable.statut_fiche}}</b-badge>
              </div>
              <span v-else-if="props.column.field === 'lien_professionnel'">
                <b-badge :variant="sourceVariant(props.row.lien_professionnel)">
                  {{ capitalizeFirstLetter(props.row.lien_professionnel) }}
                </b-badge>
              </span>
              <span v-else-if="props.column.field === 'actions'">
                <span>
                  <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                    <template v-slot:button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                    </template>
                    <b-dropdown-item @click="editProspect(props.row)">
                      <feather-icon icon="EditIcon" class="mr-50" />
                      <span>Éditer</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="removeConnexite(props.row)">
                      <feather-icon icon="TrashIcon" class="mr-50" />
                      <span>Supprimer la connexité</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
              </template>
              <!-- <template slot="pagination-bottom" slot-scope="props">
                <b-row class="align-items-center">
                  <b-col>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </template> -->
              <div slot="emptystate" class="text-center align-middle">
                <span>Aucune donn&eacute;e disponible dans le tableau</span>
              </div>
            </vue-good-table>
      </app-collapse-item>
      <app-collapse-item title="Salariés" v-if="particulierDataSalarie.length > 0">
        <card-connexite :particulier-data="particulierDataSalarie" @update-connexite-prospect="editProspect"
            @remove-connexite-prospect="removeConnexite"
            @go-to-another-fiche-client="showProspect" />
            <vue-good-table
            v-show="false"
              :columns="particulierColumns"
              :rows="particulierDataSalarie"
              :rtl="direction"
              style-class="vgt-table condensed"
              :pagination-options="{
                enabled: false,
                mode: 'records',
                perPage: pageLength,
                rowsPerPageLabel: '',
                dropdownAllowAll: false,
                perPageDropdownEnabled: false,
                nextLabel: 'Suivant',
                prevLabel: 'Précédent',
                ofLabel: 'de',
                infoFn: params => ``
              }"
            >
              <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'lienable.nom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                <a :style="[{'text-decoration': 'underline'}]">
                  {{ props.row.lienable.nom }}
                </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.prenom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                <a :style="[{'text-decoration': 'underline'}]">
                  {{ props.row.lienable.prenom }}
                </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.statut_fiche'">
                <b-badge :variant="props.row.lienable.statut_fiche ==='Ancien Client' ? typeClientVariant('Ancien') : typeClientVariant(props.row.lienable.statut_fiche)">{{ props.row.lienable.statut_fiche}}</b-badge>
              </div>
              <span v-else-if="props.column.field === 'lien_professionnel'">
                <b-badge :variant="sourceVariant(props.row.lien_professionnel)">
                  {{ capitalizeFirstLetter(props.row.lien_professionnel) }}
                </b-badge>
              </span>
              <span v-else-if="props.column.field === 'actions'">
                <span>
                  <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                    <template v-slot:button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                    </template>
                    <b-dropdown-item @click="editProspect(props.row)">
                      <feather-icon icon="EditIcon" class="mr-50" />
                      <span>Éditer</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="removeConnexite(props.row)">
                      <feather-icon icon="TrashIcon" class="mr-50" />
                      <span>Supprimer la connexité</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
              </template>
              <template slot="pagination-bottom" slot-scope="props">
                <b-row class="align-items-center">
                  <b-col>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </template>
              <div slot="emptystate" class="text-center align-middle">
                <span>Aucune donn&eacute;e disponible dans le tableau</span>
              </div>
            </vue-good-table>
      </app-collapse-item>
      <app-collapse-item title="DAF" v-if="particulierDataDaf.length > 0">
            <card-connexite :particulier-data="particulierDataDaf" @update-connexite-prospect="editProspect"
            @remove-connexite-prospect="removeConnexite"
            @go-to-another-fiche-client="showProspect" />
            <vue-good-table
              v-show="false"
              :columns="particulierColumns"
              :rows="particulierDataDaf"
              :rtl="direction"
              style-class="vgt-table condensed"
              :pagination-options="{
                enabled: false,
                mode: 'records',
                perPage: pageLength,
                rowsPerPageLabel: '',
                dropdownAllowAll: false,
                perPageDropdownEnabled: false,
                nextLabel: 'Suivant',
                prevLabel: 'Précédent',
                ofLabel: 'de',
                infoFn: params => ``
              }"
            >
              <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'lienable.nom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                    <a :style="[{'text-decoration': 'underline'}]">
                      {{ props.row.lienable.nom }}
                    </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.prenom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                <a :style="[{'text-decoration': 'underline'}]">
                  {{ props.row.lienable.prenom }}
                </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.statut_fiche'">
                <b-badge :variant="props.row.lienable.statut_fiche ==='Ancien Client' ? typeClientVariant('Ancien') : typeClientVariant(props.row.lienable.statut_fiche)">{{ props.row.lienable.statut_fiche}}</b-badge>
              </div>
              <span v-else-if="props.column.field === 'lien_professionnel'">
                <b-badge :variant="sourceVariant(props.row.lien_professionnel)">
                  {{ capitalizeFirstLetter(props.row.lien_professionnel) }}
                </b-badge>
              </span>
              <span v-else-if="props.column.field === 'actions'">
                <span>
                  <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                    <template v-slot:button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                    </template>
                    <b-dropdown-item @click="editProspect(props.row)">
                      <feather-icon icon="EditIcon" class="mr-50" />
                      <span>Éditer</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="removeConnexite(props.row)">
                      <feather-icon icon="TrashIcon" class="mr-50" />
                      <span>Supprimer la connexité</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
              </template>
              <!-- <template slot="pagination-bottom" slot-scope="props">
                <b-row class="align-items-center">
                  <b-col>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </template> -->
              <div slot="emptystate" class="text-center align-middle">
                <span>Aucune donn&eacute;e disponible dans le tableau</span>
              </div>
            </vue-good-table>
      </app-collapse-item>
      <app-collapse-item title="Expert-comptable" v-if="particulierDataComptable.length > 0">
        <card-connexite :particulier-data="particulierDataComptable" @update-connexite-prospect="editProspect"
            @remove-connexite-prospect="removeConnexite"
            @go-to-another-fiche-client="showProspect" />
            <vue-good-table
            v-show="false"
              :columns="particulierColumns"
              :rows="particulierDataComptable"
              :rtl="direction"
              style-class="vgt-table condensed"
              :pagination-options="{
                enabled: false,
                mode: 'records',
                perPage: pageLength,
                rowsPerPageLabel: '',
                dropdownAllowAll: false,
                perPageDropdownEnabled: false,
                nextLabel: 'Suivant',
                prevLabel: 'Précédent',
                ofLabel: 'de',
                infoFn: params => ``
              }"
            >
              <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'lienable.nom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                <a :style="[{'text-decoration': 'underline'}]">
                  {{ props.row.lienable.nom }}
                </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.prenom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                <a :style="[{'text-decoration': 'underline'}]">
                  {{ props.row.lienable.prenom }}
                </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.statut_fiche'">
                <b-badge :variant="props.row.lienable.statut_fiche ==='Ancien Client' ? typeClientVariant('Ancien') : typeClientVariant(props.row.lienable.statut_fiche)">{{ props.row.lienable.statut_fiche}}</b-badge>
              </div>
              <span v-else-if="props.column.field === 'lien_professionnel'">
                <b-badge :variant="sourceVariant(props.row.lien_professionnel)">
                  {{ capitalizeFirstLetter(props.row.lien_professionnel) }}
                </b-badge>
              </span>
              <span v-else-if="props.column.field === 'actions'">
                <span>
                  <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                    <template v-slot:button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                    </template>
                    <b-dropdown-item @click="editProspect(props.row)">
                      <feather-icon icon="EditIcon" class="mr-50" />
                      <span>Éditer</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="removeConnexite(props.row)">
                      <feather-icon icon="TrashIcon" class="mr-50" />
                      <span>Supprimer la connexité</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
              </template>
              <template slot="pagination-bottom" slot-scope="props">
                <b-row class="align-items-center">
                  <b-col>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </template>
              <div slot="emptystate" class="text-center align-middle">
                <span>Aucune donn&eacute;e disponible dans le tableau</span>
              </div>
            </vue-good-table>
      </app-collapse-item>
      <app-collapse-item title="Clients" v-if="particulierDataClient.length > 0">
        <card-connexite :particulier-data="particulierDataClient" @update-connexite-prospect="editProspect"
            @remove-connexite-prospect="removeConnexite"
            @go-to-another-fiche-client="showProspect" />
            <vue-good-table
              v-show="false"
              :columns="particulierColumns"
              :rows="particulierDataClient"
              :rtl="direction"
              style-class="vgt-table condensed"
              :pagination-options="{
                enabled: false,
                mode: 'records',
                perPage: pageLength,
                rowsPerPageLabel: '',
                dropdownAllowAll: false,
                perPageDropdownEnabled: false,
                nextLabel: 'Suivant',
                prevLabel: 'Précédent',
                ofLabel: 'de',
                infoFn: params => ``
              }"
            >
              <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'lienable.nom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                <a :style="[{'text-decoration': 'underline'}]">
                  {{ props.row.lienable.nom }}
                </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.prenom'" @click="showProspect(props.row.lienable.isVisible, props.row.lienable.id, props.row.lienable.categorie, props.row.lienable.type)">
                <a :style="[{'text-decoration': 'underline'}]">
                  {{ props.row.lienable.prenom }}
                </a>
              </div>
              <div v-else-if="props.column.field == 'lienable.statut_fiche'">
                <b-badge :variant="props.row.lienable.statut_fiche ==='Ancien Client' ? typeClientVariant('Ancien') : typeClientVariant(props.row.lienable.statut_fiche)">{{ props.row.lienable.statut_fiche}}</b-badge>
              </div>
              <span v-else-if="props.column.field === 'lien_professionnel'">
                <b-badge :variant="sourceVariant(props.row.lien_professionnel)">
                  {{ capitalizeFirstLetter(props.row.lien_professionnel) }}
                </b-badge>
              </span>
              <span v-else-if="props.column.field === 'actions'">
                <span>
                  <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                    <template v-slot:button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                    </template>
                    <b-dropdown-item @click="editProspect(props.row)">
                      <feather-icon icon="EditIcon" class="mr-50" />
                      <span>Éditer</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="removeConnexite(props.row)">
                      <feather-icon icon="TrashIcon" class="mr-50" />
                      <span>Supprimer la connexité</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
              </span>
              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
              </template>
              <template slot="pagination-bottom" slot-scope="props">
                <b-row class="align-items-center">
                  <b-col>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </template>
              <div slot="emptystate" class="text-center align-middle">
                <span>Aucune donn&eacute;e disponible dans le tableau</span>
              </div>
            </vue-good-table>
      </app-collapse-item>
      <!--  -->
      <!--  -->
      <app-collapse-item title="Actionnaire de" v-if="entrepriseDataActionnaireDe.length > 0">
        <card-connexite :particulier-data="entrepriseDataActionnaireDe" @update-connexite-prospect="editProspect"
            @remove-connexite-prospect="removeConnexite"
            @go-to-another-fiche-client="showProspect" />
            <vue-good-table
              v-show="false"
              :columns="entrepriseColumns"
              :rows="entrepriseDataActionnaireDe"
              :rtl="direction"
              style-class="vgt-table condensed"
              :pagination-options="{
                enabled: false,
                mode: 'records',
                perPage: pageLength,
                rowsPerPageLabel: '',
                dropdownAllowAll: false,
                perPageDropdownEnabled: false,
                nextLabel: 'Suivant',
                prevLabel: 'Précédent',
                ofLabel: 'de',
                infoFn: params => ``
              }"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'lien_professionnel'">
                  <b-badge :variant="sourceVariant(props.row.lien_professionnel)">
                    {{ capitalizeFirstLetter(props.row.lien_professionnel) }}
                  </b-badge>
                </span>
                <span v-else-if="props.column.field === 'actions'">
                  <span>
                    <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                      <template v-slot:button-content>
                        <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                      </template>
                      <b-dropdown-item @click="editEntreprise(props.row)">
                        <feather-icon icon="EditIcon" class="mr-50" />
                        <span>Éditer</span>
                      </b-dropdown-item>
                      <b-dropdown-item @click="removeConnexite(props.row)">
                        <feather-icon icon="TrashIcon" class="mr-50" />
                        <span>Supprimer la connexité</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <b-row class="mt-2 align-items-center">
                  <b-col>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </template>
              <div slot="emptystate" class="text-center align-middle">
                <span>Aucune donn&eacute;e disponible dans le tableau</span>
              </div>
            </vue-good-table>
      </app-collapse-item>
      <app-collapse-item title="Détenu par" v-if="entrepriseDataDetenuPar.length > 0">
        <card-connexite :particulier-data="entrepriseDataDetenuPar" @update-connexite-prospect="editProspect"
            @remove-connexite-prospect="removeConnexite"
            @go-to-another-fiche-client="showProspect" />
            <vue-good-table
              v-show="false"
              :columns="entrepriseColumns"
              :rows="entrepriseDataDetenuPar"
              :rtl="direction"
              style-class="vgt-table condensed"
              :pagination-options="{
                enabled: false,
                mode: 'records',
                perPage: pageLength,
                rowsPerPageLabel: '',
                dropdownAllowAll: false,
                perPageDropdownEnabled: false,
                nextLabel: 'Suivant',
                prevLabel: 'Précédent',
                ofLabel: 'de',
                infoFn: params => ``
              }"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'lien_professionnel'">
                  <b-badge :variant="sourceVariant(props.row.lien_professionnel)">
                    {{ capitalizeFirstLetter(props.row.lien_professionnel) }}
                  </b-badge>
                </span>
                <span v-else-if="props.column.field === 'actions'">
                  <span>
                    <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                      <template v-slot:button-content>
                        <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                      </template>
                      <b-dropdown-item @click="editEntreprise(props.row)">
                        <feather-icon icon="EditIcon" class="mr-50" />
                        <span>Éditer</span>
                      </b-dropdown-item>
                      <b-dropdown-item @click="removeConnexite(props.row)">
                        <feather-icon icon="TrashIcon" class="mr-50" />
                        <span>Supprimer la connexité</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <b-row class="mt-2 align-items-center">
                  <b-col>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </template>
              <div slot="emptystate" class="text-center align-middle">
                <span>Aucune donn&eacute;e disponible dans le tableau</span>
              </div>
            </vue-good-table>
      </app-collapse-item>
      <app-collapse-item title="Filiale / Société mère" v-if="entrepriseDataFilialeSocieteMere.length > 0">
        <card-connexite :particulier-data="entrepriseDataFilialeSocieteMere" @update-connexite-prospect="editProspect"
            @remove-connexite-prospect="removeConnexite"
            @go-to-another-fiche-client="showProspect" />
            <vue-good-table
              v-show="false"
              :columns="entrepriseColumns"
              :rows="entrepriseDataFilialeSocieteMere"
              :rtl="direction"
              style-class="vgt-table condensed"
              :pagination-options="{
                enabled: false,
                mode: 'records',
                perPage: pageLength,
                rowsPerPageLabel: '',
                dropdownAllowAll: false,
                perPageDropdownEnabled: false,
                nextLabel: 'Suivant',
                prevLabel: 'Précédent',
                ofLabel: 'de',
                infoFn: params => ``
              }"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'lien_professionnel'">
                  <b-badge :variant="sourceVariant(props.row.lien_professionnel)">
                    {{ capitalizeFirstLetter(props.row.lien_professionnel) }}
                  </b-badge>
                </span>
                <span v-else-if="props.column.field === 'actions'">
                  <span>
                    <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                      <template v-slot:button-content>
                        <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                      </template>
                      <b-dropdown-item @click="editEntreprise(props.row)">
                        <feather-icon icon="EditIcon" class="mr-50" />
                        <span>Éditer</span>
                      </b-dropdown-item>
                      <b-dropdown-item @click="removeConnexite(props.row)">
                        <feather-icon icon="TrashIcon" class="mr-50" />
                        <span>Supprimer la connexité</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <b-row class="mt-2 align-items-center">
                  <b-col>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </template>
              <div slot="emptystate" class="text-center align-middle">
                <span>Aucune donn&eacute;e disponible dans le tableau</span>
              </div>
            </vue-good-table>
      </app-collapse-item>
      <app-collapse-item title="Filiale de" v-if="entrepriseDataFilialeDe.length > 0">
        <card-connexite :particulier-data="entrepriseDataFilialeDe" @update-connexite-prospect="editProspect"
            @remove-connexite-prospect="removeConnexite"
            @go-to-another-fiche-client="showProspect" />
            <vue-good-table
              v-show="false"
              :columns="entrepriseColumns"
              :rows="entrepriseDataFilialeDe"
              :rtl="direction"
              style-class="vgt-table condensed"
              :pagination-options="{
                enabled: false,
                mode: 'records',
                perPage: pageLength,
                rowsPerPageLabel: '',
                dropdownAllowAll: false,
                perPageDropdownEnabled: false,
                nextLabel: 'Suivant',
                prevLabel: 'Précédent',
                ofLabel: 'de',
                infoFn: params => ``
              }"
            >
              <template slot="table-row" slot-scope="props">
                <!-- Column: Action -->
                <span v-if="props.column.field === 'lien_professionnel'">
                  <b-badge :variant="sourceVariant(props.row.lien_professionnel)">
                    {{ capitalizeFirstLetter(props.row.lien_professionnel) }}
                  </b-badge>
                </span>
                <span v-else-if="props.column.field === 'actions'">
                  <span>
                    <b-dropdown variant="link" toggle-class="text-decoration-none p-0" no-caret>
                      <template v-slot:button-content>
                        <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                      </template>
                      <b-dropdown-item @click="editEntreprise(props.row)">
                        <feather-icon icon="EditIcon" class="mr-50" />
                        <span>Éditer</span>
                      </b-dropdown-item>
                      <b-dropdown-item @click="removeConnexite(props.row)">
                        <feather-icon icon="TrashIcon" class="mr-50" />
                        <span>Supprimer la connexité</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="props">
                <b-row class="mt-2 align-items-center">
                  <b-col>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" @input="value => props.pageChanged({ currentPage: value })">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </b-col>
                </b-row>
              </template>
              <div slot="emptystate" class="text-center align-middle">
                <span>Aucune donn&eacute;e disponible dans le tableau</span>
              </div>
            </vue-good-table>
      </app-collapse-item>
    </app-collapse>
  </div>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { BDropdown, BDropdownItem, BPagination,BFormRadioGroup, BFormRadio, BFormGroup,BCol,BRow,BBadge,BOverlay} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import Data from "@/shared/constants/prospect";
import UpdatedFicheEntrepriseProspectLien from '../actions-fiche-entreprise/UpdatedFicheEntrepriseProspectLien.vue'
import store from '@/store/index'
import CardConnexite from '../../global-components/CardConnexite.vue'

export default {
  components: {
    AppCollapse,
    AppCollapseItem,
    BCol,
    BRow,
    BBadge,
    VueGoodTable,
    BDropdown, 
    BDropdownItem, 
    BPagination,
    UpdatedFicheEntrepriseProspectLien,
    BOverlay,
    CardConnexite
  },
  props: {
    tiersData: {
      type: Object,
      default: {},
      required: true
    }
  },
  computed:{
    getFormeJuridique: function () {
    let findEntreprise = this.FormJuridique.find(obj => {
           return obj.value === this.entreprise.forme_juridique;
        }); 
        return findEntreprise ? findEntreprise.text : ''
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
    // particulierDataDirigeant: function () {
    //   return this.particulierData.filter(value => {
    //       return value.lien_familial == 'CONJOINT';
    //   }); 
    // },
    particulierDataDaf: function () {
      return this.particulierData.filter(value => {
          return value.lien_professionnel == 'DAF';
      }); 
    },
    particulierDataDirigeant: function () {
      return this.particulierData.filter(value => {
          return value.lien_professionnel == 'DIRIGEANT';
      }); 
    },
    particulierDataSalarie: function () {
      return this.particulierData.filter(value => {
          return value.lien_professionnel == 'SALARIE';
      }); 
    },
    particulierDataAssocie: function () {
      return this.particulierData.filter(value => {
          return value.lien_professionnel == 'ASSOCIE';
      }); 
    },
    particulierDataComptable: function () {
      return this.particulierData.filter(value => {
          return value.lien_professionnel == 'EXPERT COMPTABLE';
      }); 
    },
    particulierDataClient: function () {
      return this.particulierData.filter(value => {
          return value.lien_professionnel == 'CLIENT';
      }); 
    },
    entrepriseDataActionnaireDe: function () {
      return this.particulierData.filter(value => {
          return value.lien_professionnel == 'ACTIONNAIRE_DE';
      }); 
    },
    entrepriseDataDetenuPar: function () {
      return this.particulierData.filter(value => {
          return value.lien_professionnel == 'DETENU_PAR';
      }); 
    },
    entrepriseDataFilialeSocieteMere: function () {
      return this.particulierData.filter(value => {
          return value.lien_professionnel == 'FILIALE_SOCIETE_MERE';
      }); 
    },
    entrepriseDataFilialeDe: function () {
      return this.particulierData.filter(value => {
          return value.lien_professionnel == 'FILIALE_DE';
      }); 
    },
  },
  data() {
    return {
      showLoading: false,
      dir: false,
      options: {
        phone: {
          blocks: [2, 2, 2, 2, 2],
          uppercase: true
        },
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralDecimalMark: ',',
          delimiter: ' '
        }
      },
      configDate: {
        dateFormat: 'd/m/Y',
        allowInput: true,
        onKeyDown: (selectedDates, dateStr, instance, event) => {
          if (event.keyCode != 8) {
            const ele = document.activeElement
            let val = ele.value

            if ((val.length == 2 || val.length == 5) && ele.getAttribute('id')) {
              val += '/'
            }
            ele.value = val
            ele.dispatchEvent(new Event('input'))
          }
        }
      },
      FormJuridique : Data["FORMEJURIDIQUE"],
      villeOptions: [],
      codeNafOptions: [],
      particulierData:[],
      pageLength: 3,
      prospectPrincipal:{},
      prospectLocal:{
        id:null,
        type:null
      },
      entrepriseColumns: [
        // { label: 'objet de la formation ', field: 'objet', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Dénominitation Commerciale', field: 'lienable.denomination_commercial', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Siret', field: 'lienable.siret', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Activité', field: 'lienable.activite', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Date de création', field: 'lienable.date_creation', type: 'date', dateInputFormat: 'yyyy-MM-dd', dateOutputFormat: 'dd/MM/yyyy', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Fonction', field: 'lien_professionnel', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { field: 'actions', label: 'Actions', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' }
      ],
      particulierColumns: [
        // { label: 'objet de la formation ', field: 'objet', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        // { label: 'Civilité', field: 'lienable.civilite', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Nom', field: 'lienable.nom', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Prénom', field: 'lienable.prenom', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Statut', field: 'lienable.statut_fiche', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { label: 'Date de naissance', field: 'lienable.date_naissance', type: 'date', dateInputFormat: 'yyyy-MM-dd', dateOutputFormat: 'dd/MM/yyyy', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        // { label: 'Famille', field: 'lien_familial', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' },
        { field: 'actions', label: 'Actions', sortable: false, thClass: 'text-center align-middle bg-primary text-white unbreaking h6', tdClass: 'text-center m-0 p-1 align-middle h6' }
      ],
    }
  },
  watch: {
    tiersData: {
      deep: true,
      handler() {
        this.affectedDataTierToComposeData()
      }
    },
    'professionnel.code_postal': {
      immediate: true,
      handler(val) {
        if (val) this.GetVille(val)
      }
    },
  },
  mounted(){
    // this.GetCodeNAF()
  },
  methods: {
    GetCodeNAF(){
      this.$http.get(`tiers/getCodeNAf`)
          .then((r) => {
            this.codeNafOptions = r.data
          })
          .catch((e)=>{
            console.log(e);
          })
    },
    GetVille(code) {
      if (code && code.length === 5) {
        this.$http
            .get(`/helpers/${code}/villes`)
            .then(res => {
              if (res.data?.length > 0) {
                this.villeOptions = [...res.data]
              }
            })
            .catch(err => {
              console.log(err)
            })
      } else {
        this.villeOptions = []
      }
    },
    UpdateClientEntrepriseReturned(data, message){
      this.$emit('update-client-entreprise-returned',data,message)
    },
    affectedDataTierToComposeData() {
      if(this.tiersData.prospect != null) {
        console.log('khadamnin')
        console.log(this.tiersData.prospect)
        this.particulierData = this.tiersData.prospect.filter(obj => {
            return obj.lien_familial == null  ; 
        });
      } else this.particulierData = []
    },
    hideSideBare() {
      this.$refs.sideBarClientEntreprise.hide()
    },
    sourceVariant(status) {
      const statusColor = {
        CONJOINT: 'light-primary',
        ENFANT: 'light-warning',
        PARENT: 'light-danger',
        AMI: 'light-success',
      }
      return statusColor[status]
    },
    typeClientVariant(categorie) {
      try {
        const typeClientColor = {
          /* eslint-disable key-spacing */
          Prospect: 'light-danger',
          Client: 'light-warning',
          Ancien: 'light-success',
          Aucun: 'light-dark',
          /* eslint-enable key-spacing */
        }
        if (categorie) {
          return typeClientColor[categorie]
        }
        return null
      } catch (e) {
        return null
      }
    },
    updateTiersEntreprise() {
      this.$refs.clientEntrepriseComposeRules.validate()
          .then(success => {
            if (success) {
              this.showLoading = true
              this.$http
                  .post('/prospect/updateTiersEntreprise', this.composeData)
                  .then(res => {
                    if (res.data.success) {
                      this.$emit('update-client-entreprise-returned', res.data.data, res.data.message)
                      this.hideSideBare()
                      this.showLoading = false
                    }
                  })
                  .catch(err => {
                    this.showLoading = false
                    this.messageToast(err.response.data.errors[0], 'Erreur', 'error')
                    console.error(err)
                  })
            }
          })
    },
    editProspect(data){
        this.prospectLocal.id=this.tiersData.id
        this.prospectLocal.type=this.tiersData.type
        this.prospectPrincipal = data.lienable
        this.$root.$emit('bv::toggle::collapse', 'sidebar-client-entreprise-prospect-custom')
    },
    removeConnexite(data){
      let meta ={
        prospect:{id:this.tiersData.id,type:this.tiersData.type},
        connexite:{id:data.lienable.id,type:data.lienable.type}
      }

      this.$swal({
        title: "Êtes-vous sûr ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.showLoading=true
          this.$http
            .post('/prospect/removeConnexiteMorale', meta)
            .then(res => {
              if (res.data) {
                this.$emit('update-client-entreprise-returned', res.data.data, res.data.message)
                this.showLoading=false
              }
            })
            .catch(err => {
              this.showLoading = false
              this.messageToast(err.response.data.errors[0], 'Erreur', 'error')
              console.error(err)
            })
        }
      });
    },
    showProspect(isVisible, prospectId, prospectCategorie, prospectType) {
      this.$emit('go-to-another-fiche-client', prospectId, prospectType, prospectCategorie)
    },
  }
}
</script>
<style>
.vgt-responsive{
  min-height: 0px;
}
</style>